import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Google Analytics 4 Integration
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-XXXXXXXXXX';

// Initialize Google Analytics
export const initGA = () => {
  // Load Google Analytics script
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script1);

  // Initialize gtag
  const script2 = document.createElement('script');
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${GA_MEASUREMENT_ID}', {
      page_title: document.title,
      page_location: window.location.href,
      send_page_view: true
    });
  `;
  document.head.appendChild(script2);
};

// Track page views
export const trackPageView = (path, title) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: path,
      page_title: title,
    });
  }
};

// Track custom events
export const trackEvent = (action, category, label, value) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Track user engagement events
export const trackUserEngagement = {
  // Track when user starts practice session
  startPractice: (type) => {
    trackEvent('start_practice', 'engagement', type);
  },
  
  // Track when user completes a problem
  completeProblem: (problemType, difficulty) => {
    trackEvent('complete_problem', 'achievement', `${problemType}_${difficulty}`);
  },
  
  // Track AI feedback usage
  useAIFeedback: (context) => {
    trackEvent('ai_feedback', 'feature_usage', context);
  },
  
  // Track login/signup
  userAuth: (action) => {
    trackEvent(action, 'auth', 'user_authentication');
  },
  
  // Track feature usage
  useFeature: (featureName) => {
    trackEvent('feature_use', 'interaction', featureName);
  }
};

// React component for Google Analytics
const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialize GA on first load
    initGA();
  }, []);

  useEffect(() => {
    // Track page views on route changes
    trackPageView(location.pathname + location.search, document.title);
  }, [location]);

  return null;
};

// Hook for tracking events in components
export const useAnalytics = () => {
  return {
    trackEvent,
    trackPageView,
    trackUserEngagement
  };
};

export default GoogleAnalytics;
